<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     设备选择器-远程搜索
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-select v-model="memberid" :placeholder="placeholder" filterable
    remote :remote-method="remoteMethod" clearable @change="selectChange" @focus="focus" :style="{ width: width + 'px' }">
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item.nickname"
      :value="item.memberid"
      class="f-member-selector-option flex align-items-center"
    >
      <div class="flex align-items-center">
        <f-user-avatar :src="item.avatar" size="mini" :preview="false"></f-user-avatar>
        <div class="ml-sm" style="line-height: 1;">
          <span>{{ item.nickname }}</span>
          <el-rate v-if="item.customer_level" v-model="item.customer_level" class="mt-xs" disabled-void-color="transparent" disabled></el-rate>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { getfewMemberApi } from '@/api/up/upMemberApi'

export default {
  name: "FMemberSelector",

  props: {
    value: {
      type: Number,
      default: 0
    },

    placeholder: {
      type: String,
      default: '用户'
    },

    width: {
			type: String,
			default: '160'
		}
  },

  data() {
    return {
      options: []
    }
  },

  computed: {
    memberid: {
      get() {
        return this.value ? this.value : null
      },
      set(val) {
        this.$emit('input', val ? val : null)
      }
    }
  },

  created() {
    this.fetchData()
  },

  watch: {
  },

  methods: {
    remoteMethod(query) {
      getfewMemberApi({ keyword: query, num: 10 }).then(res => {
        if (!res.errno) {
          this.options = res.data.list
        }
      })
    },

    focus() {
      if (!this.memberid) this.fetchData()
    },

    fetchData() {
      getfewMemberApi().then(res => {
        if (!res.errno) {
          this.options = res.data.list
        }
      })
    },

    selectChange(val) {
      const list = this.options.map(v => v.memberid)
      const index = list.indexOf(val)
      const item = this.options[index]
      this.$emit('change', item)
    },

  }
}
</script>

<style lang="scss" scoped>
.f-member-selector-option {
  height: 50px;
  cursor: pointer;

  .el-rate {
    /deep/ .el-rate__item {
      .el-rate__icon {
        font-size: 18px;
      }
    }
  }
}
</style>
